module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figA04_lead-zone-based-evaluation-end-relief.6a21e271.png";